import {Popup} from '@mintdata/mint-kit/impl/components/popover/Popup';
import {
    PopupId,
    PopupKind,
    ReadIsVisibleFn,
    ReadWriteIsVisibleFn,
    WriteIsVisibleFn,
} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import * as React from 'react';

export class Popover extends Popup
{
    private static _nextAvailableId:number = 0;

    public getKind():PopupKind
    {
        return PopupKind.Popover;
    }

    public static nextAutoId():PopupId
    {
        return `popup-autoid-${this._nextAvailableId++}`;
    }

    public static isVisible(readFn:ReadIsVisibleFn, writeFn:WriteIsVisibleFn):ReadWriteIsVisibleFn
    {
        return (maybeArg?:boolean) =>
        {
            if( maybeArg !== undefined )
                writeFn(maybeArg);
            else
                return readFn();
        };
    }
}
